import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { status, user } = useAuth();
  const location = useLocation();
  if (status === 'loading') {
    return <div className="min-h-screen flex items-center justify-center text-stone-500">Loading…</div>;
  }
  if (status === 'unauthenticated' || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  // Worker app is for the 'worker' group only; staff use admin.fixitninjaz.com.
  if (!user.groups.includes('worker') && !user.groups.includes('super_admin')) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-center text-stone-700">
        This account is not registered as a worker. Use the admin portal instead.
      </div>
    );
  }
  return <>{children}</>;
}
